import { useState } from "react";
import ChangeQuantity from "../../feature/ChangeQuantity/ChangeQuantity";
import { Button } from "../../shared/ui/Button/Button";
import { Text } from "../../shared/ui/Text/Text";
import styles from './Dental.module.scss';
import { useDispatch } from "react-redux";
import { addItemToCart } from "../../redux/CartSlice";



const Dental = ({dent}) => {
   const [quantity, setQuantity] = useState(1);
   const dispatch = useDispatch()


    return ( 
   
        <div>
    
         <div className={styles.contant}>
            <Text className={styles.text__left}>
               {dent.serviceName}
            </Text>
            <Text className={styles.text}>
               {dent.price} 
            </Text>
   
            <ChangeQuantity  quantity ={quantity} setQuantity = {setQuantity}/>
            <Button variant="secondary" className={styles.btn} onClick={() => {dispatch(addItemToCart({dent, quantity}))}}>добавить</Button>
         </div>
        </div>
     );
}
 
export default Dental;